import { FixedColumnDirection } from 'models/enums/table';
import { getCustomDate } from 'utils/formatTimePeriod';
import {
  addToolTip,
  formatNumericValues,
  formatAccountingValues,
} from 'utils/commonFunction';
import React from 'react';
import { AppSetting } from 'utils/appSettings';

const commonWidth = 100;

export const listingHeaders = [
  {
    title: 'PO Number',
    dataIndex: 'po_number',
    width: commonWidth,
    fixed: FixedColumnDirection.left,
    canSort: true,
    dataRender: (poNumber: string) =>
      poNumber &&
      poNumber.split(', ').map((id, index) => (
        <React.Fragment key={id}>
          {index > 0 && ', '}
          <a
            target="_blank"
            rel="noreferrer"
            href={AppSetting.PURCHASE_ID_URL + id}
          >
            {id}
          </a>
        </React.Fragment>
      )),
  },
  {
    title: 'Seat Map Creation Date',
    dataIndex: 'seat_map_creation_date',
    canSort: true,
    width: commonWidth,
    dataRender: (seatMapCreationDate: string | null) =>
      seatMapCreationDate &&
      getCustomDate(seatMapCreationDate, AppSetting.REPORT_DATE_FORMAT),
  },
  {
    title: 'Seat Map Creator',
    dataIndex: 'seat_map_creator',
    canSort: true,
    width: commonWidth,
    tdClassName: 'text-capitalize',
  },
  {
    title: 'Seat Map Checker',
    dataIndex: 'seat_map_checker',
    canSort: false,
    width: commonWidth,
    tdClassName: 'text-capitalize',
    dataRender: (seatMapChecker: string[]) =>
      seatMapChecker && seatMapChecker.length ? seatMapChecker.join(', ') : '',
  },
  {
    title: 'Listing Date',
    dataIndex: 'listing_date',
    width: commonWidth,
    fixed: FixedColumnDirection.left,
    canSort: true,
    dataRender: (listingDate: string) =>
      listingDate && getCustomDate(listingDate, AppSetting.REPORT_DATE_FORMAT),
  },
  {
    title: 'Last Updated Date',
    dataIndex: 'last_updated_date',
    canSort: true,
    width: commonWidth,
    dataRender: (lastUpdatedDate: string | null) =>
      lastUpdatedDate &&
      getCustomDate(lastUpdatedDate, AppSetting.REPORT_DATE_FORMAT),
  },
  {
    title: 'No. of Times Checked',
    dataIndex: 'total_seat_map_checked',
    canSort: true,
    width: commonWidth,
    thClassName: 'text-right',
    dataRender: (totalSeatMapChecked: number) => (
      <div className="text-right">
        {formatNumericValues(totalSeatMapChecked)}
      </div>
    ),
  },
  {
    title: 'Event Name',
    dataIndex: 'event_name',
    canSort: true,
    width: commonWidth,
    tdClassName: 'text-capitalize',
    dataRender: (eventName: string) =>
      eventName?.length > 40 ? (
        addToolTip(eventName, 'right', 'default', 40, false, {
          textTransform: 'capitalize',
        })
      ) : (
        <div className="text-capitalize">{eventName}</div>
      ),
  },
  {
    title: 'Event Category',
    dataIndex: 'event_category',
    canSort: true,
    width: commonWidth,
    tdClassName: 'text-capitalize',
  },
  {
    title: 'Event Type',
    dataIndex: 'event_type',
    canSort: true,
    width: commonWidth,
    tdClassName: 'text-capitalize',
  },
  {
    title: 'Venue',
    dataIndex: 'venue_name',
    canSort: true,
    width: commonWidth,
    tdClassName: 'text-capitalize',
    dataRender: (venueName: any) =>
      (venueName && venueName.length) >= 18 ? (
        addToolTip(venueName, 'right', 'default', 18, false, {
          textTransform: 'capitalize',
        })
      ) : (
        <div className="text-capitalize">{venueName}</div>
      ),
  },
  {
    title: 'City',
    dataIndex: 'venue_city',
    canSort: true,
    width: commonWidth,
    tdClassName: 'text-capitalize',
  },
  {
    title: 'State',
    dataIndex: 'venue_state',
    canSort: true,
    width: commonWidth,
    tdClassName: 'text-upper',
  },
  {
    title: 'Event Date',
    dataIndex: 'event_date',
    canSort: true,
    width: commonWidth,
    dataRender: (eventDate: string) =>
      eventDate && getCustomDate(eventDate, AppSetting.REPORT_DATE_FORMAT),
  },
  {
    title: 'Broker',
    dataIndex: 'broker_name',
    canSort: false,
    width: commonWidth,
    tdClassName: 'text-capitalize',
    dataRender: (brokerName: string[]) =>
      brokerName && brokerName.length ? brokerName.join(', ') : '',
  },
  {
    title: 'Lister',
    dataIndex: 'lister_name',
    canSort: true,
    width: commonWidth,
    tdClassName: 'text-capitalize',
  },
  {
    title: 'List Qty',
    dataIndex: 'list_quantity',
    canSort: true,
    width: commonWidth,
    thClassName: 'text-right',
    dataRender: (listQuantity: number) => (
      <div className="text-right">{formatNumericValues(listQuantity)}</div>
    ),
  },
  {
    title: 'Section',
    dataIndex: 'section',
    canSort: true,
    width: commonWidth,
    tdClassName: 'text-capitalize',
  },
  {
    title: 'Row',
    dataIndex: 'row',
    canSort: true,
    width: commonWidth,
    tdClassName: 'text-upper',
  },
  {
    title: 'Cost',
    dataIndex: 'price_per_ticket',
    canSort: true,
    width: commonWidth,
    thClassName: 'text-right',
    dataRender: (pricePerTicket: number) => (
      <div className={`text-right ${pricePerTicket < 0 ? 'text-danger' : ''}`}>
        {formatAccountingValues(pricePerTicket)}
      </div>
    ),
  },
  {
    title: 'List Price',
    dataIndex: 'list_price',
    canSort: true,
    width: commonWidth,
    thClassName: 'text-right',
    dataRender: (listPrice: number) => (
      <div className={`text-right ${listPrice < 0 ? 'text-danger' : ''}`}>
        {formatAccountingValues(listPrice)}
      </div>
    ),
  },
  // {
  //   title: 'Cost Value',
  //   dataIndex: 'cost_value',
  //   canSort: true,
  //   width: commonWidth,
  //   thClassName: 'text-right',
  //   dataRender: (costValue: number) => (
  //     <div className={`text-right ${costValue < 0 ? 'text-danger' : ''}`}>
  //       {formatAccountingValues(costValue)}
  //     </div>
  //   ),
  // },
  {
    title: 'Availability',
    dataIndex: 'availability',
    canSort: true,
    width: commonWidth,
    tdClassName: 'text-center',
    dataRender: (availability: any) => <div>{availability ?? '-'}</div>,
  },
  {
    title: 'Row No. of Lowest Price',
    dataIndex: 'row_no_of_lowest_price',
    canSort: true,
    width: commonWidth,
    dataRender: (rowNo: string | null) => <div>{rowNo ?? '-'}</div>,
  },
  {
    title: 'Adjusted Min Price',
    dataIndex: 'adjusted_min_price',
    canSort: true,
    width: commonWidth,
    thClassName: 'text-right',
    dataRender: (minPrice: number | null) => (
      <div className="text-right">
        {minPrice === null || minPrice === undefined
          ? '-'
          : formatAccountingValues(minPrice)}
      </div>
    ),
  },
  {
    title: 'Adjusted Max Price',
    dataIndex: 'adjusted_max_price',
    canSort: true,
    width: commonWidth,
    thClassName: 'text-right',
    dataRender: (maxPrice: number | null) => (
      <div className="text-right">
        {maxPrice === null || maxPrice === undefined
          ? '-'
          : formatAccountingValues(maxPrice)}
      </div>
    ),
  },
  {
    title: 'Adjusted Average Price',
    dataIndex: 'adjusted_average_price',
    canSort: true,
    width: commonWidth,
    thClassName: 'text-right',
    dataRender: (avgPrice: number | null) => (
      <div className="text-right">
        {avgPrice === null || avgPrice === undefined
          ? '-'
          : formatAccountingValues(avgPrice)}
      </div>
    ),
  },
  {
    title: 'Adjusted Median Price',
    dataIndex: 'adjusted_median_price',
    canSort: true,
    width: commonWidth,
    thClassName: 'text-right',
    dataRender: (medianPrice: number | null) => (
      <div className="text-right">
        {medianPrice === null || medianPrice === undefined
          ? '-'
          : formatAccountingValues(medianPrice)}
      </div>
    ),
  },
  /* Recommendation column commented out per request
  {
    title: 'Recommendation',
    dataIndex: 'recommendation_flag',
    canSort: true,
    width: commonWidth,
    thClassName: 'text-center',
    dataRender: (recommendation: any) => (
      <div className="text-center">{recommendation ?? '-'}</div>
    ),
  },
  */
  /* Recommended Adjusted Price column commented out per request
  {
    title: 'Recommendation',
    dataIndex: 'recommendation_flag',
    canSort: true,
    width: commonWidth,
    thClassName: "text-center",
    dataRender: (recommendation: any) => <div className='text-center'>{recommendation ?? '-'}</div>,
  },
  {
    title: 'Recommended Adjusted Price',
    dataIndex: 'recommended_adjusted_price',
    canSort: true,
    width: commonWidth,
    thClassName: 'text-right',
    dataRender: (recommendedPrice: number | null) => (
      <div className="text-right">
        {recommendedPrice === null || recommendedPrice === undefined
          ? '-'
          : formatAccountingValues(recommendedPrice)}
      </div>
    ),
  },
  */
  {
    title: 'Rank',
    dataIndex: 'row_competitive_rank',
    canSort: true,
    width: commonWidth,
    thClassName: 'text-center',
    dataRender: (rank: string | null) => (
      <div className="text-center">{rank ?? '-'}</div>
    ),
  },
  {
    title: 'MARKET PRICE UPDATED ON',
    dataIndex: 'market_price_updated_on',
    canSort: true,
    thClassName: 'text-left lastUpdateCol',
    width: commonWidth,
    dataRender: (marketPriceUpdatedOn: string | null) =>
      marketPriceUpdatedOn &&
      getCustomDate(marketPriceUpdatedOn, AppSetting.REPORT_DATE_FORMAT),
  },
  {
    title: 'Inventory Tag',
    dataIndex: 'broker_tag',
    canSort: true,
    width: commonWidth,
  },
  {
    title: 'Broadcast Status',
    dataIndex: 'broadcast',
    canSort: true,
    width: commonWidth,
    dataRender: (broadcast: boolean) => <div>{broadcast ? 'Yes' : 'No'}</div>,
  },
  // {
  //   title: 'TB2.0',
  //   dataIndex: 'is_platform_listing',
  //   canSort: true,
  //   width: commonWidth,
  //   dataRender: (isPlatformListing: boolean) => (
  //     <div>{isPlatformListing ? 'Yes' : ''}</div>
  //   ),
  // },
  {
    title: 'Invoice Id',
    dataIndex: 'invoice_id',
    canSort: true,
    width: commonWidth,
    dataRender: (invoiceId: any) =>
      invoiceId && (
        <a
          target="_blank"
          rel="noreferrer"
          href={AppSetting.INVOICE_ID_URL + invoiceId}
        >
          {invoiceId}
        </a>
      ),
  },
  {
    title: 'Invoice Date',
    dataIndex: 'invoice_date',
    canSort: true,
    width: commonWidth,
    dataRender: (invoiceDate: string) =>
      invoiceDate && getCustomDate(invoiceDate, AppSetting.REPORT_DATE_FORMAT),
  },
  {
    title: 'Selling Price per Seat',
    dataIndex: 'selling_price_per_ticket',
    canSort: true,
    width: commonWidth,
    thClassName: 'text-right',
    dataRender: (sellingPricePerTicket: number) => (
      <div
        className={`text-right ${
          sellingPricePerTicket < 0 ? 'text-danger' : ''
        }`}
      >
        {formatAccountingValues(sellingPricePerTicket)}
      </div>
    ),
  },
  {
    title: 'Qty Sold',
    dataIndex: 'quantity',
    canSort: true,
    width: commonWidth,
    thClassName: 'text-right',
    dataRender: (qty: number) => (
      <div className="text-right">{formatNumericValues(qty)}</div>
    ),
  },
  {
    title: 'Sale Value',
    dataIndex: 'sale_value',
    canSort: true,
    width: commonWidth,
    thClassName: 'text-right',
    dataRender: (saleValue: number) => (
      <div className={`text-right ${saleValue < 0 ? 'text-danger' : ''}`}>
        {formatAccountingValues(saleValue)}
      </div>
    ),
  },
  {
    title: 'Gross Profit',
    dataIndex: 'gross_profit',
    canSort: true,
    width: commonWidth,
    thClassName: 'text-right',
    dataRender: (grossProfit: number) => (
      <div className={`text-right ${grossProfit < 0 ? 'text-danger' : ''}`}>
        <b>{formatAccountingValues(grossProfit)}</b>
      </div>
    ),
  },
];
